import { formatNumberForDisplay } from "shared/imports/sharedHelperFunctions"

/**
* This function grabs the appropriate SocialUser fields depending on the SocialUserType. ex: Tweets and Followers for Twitter.
* We also format the numbers so they fit in the SocialUserButton.
* @name generateSocialUserDetails
* @function
* @param {Object} socialUser - Object containing stats like followers, tweets, etc. for all SocialUserTypes
* @param {Object} socialUserType - SocialUserType to select the appropriate fields
* @returns {Array} - An Array of objects in the form { label: string, value: string }
*/
export const generateSocialUserDetails = (socialUser, socialUserType) => {
    const formatNumber = number => formatNumberForDisplay(number, 1, 1e6)

    const details = []
    switch (socialUserType.value) {
        case DjangIO.app.social.models.SocialUserType.twitter_user.value:
            details.push({ label: "Tweets", value: formatNumber(socialUser.get("tweet_count")) })
            details.push({ label: "Followers", value: formatNumber(socialUser.get("followers_count")) })
            break

        case DjangIO.app.social.models.SocialUserType.facebook_user.value:
            details.push({ label: "Likes", value: formatNumber(socialUser.get("likes")) })
            details.push({ label: "Followers", value: formatNumber(socialUser.get("followers_count")) })
            break

        case DjangIO.app.social.models.SocialUserType.instagram_user.value:
            details.push({ label: "Followers", value: formatNumber(socialUser.get("followers_count")) })
            break

        case DjangIO.app.social.models.SocialUserType.youtube_user.value:
            details.push({ label: "Followers", value: formatNumber(socialUser.get("followers_count")) })
            break

        case DjangIO.app.social.models.SocialUserType.medium_user.value:
            details.push({ label: "Posts", value: formatNumber(socialUser.get("posts")) })
            break

        default:
            break
    }

    return details
}

/**
* @name generateSocialUserUrl
* @function
* @param {Object} socialUser - Object containing the username of the SocialMedia account that will be linked to
* @param {Object} socialUserType - SocialUserType contains the URL to build the link to the given SocialMedia account
* @returns {String} - URL of the Social Media profile
*/
export const generateSocialUserUrl = (socialUser, socialUserType) => {
    if (socialUser.get("user_url")) {
        return `${socialUser.get("user_url")}`
    }

    if (socialUserType.platform_name === "Youtube") {
        return `${socialUserType.profile_url.replace("user", "channel")}${socialUser.get("userid")}`
    }

    return `${socialUserType.profile_url}${socialUser.get("username")}`
}
